import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LoginComponent } from "./components/login/login.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AuthRoutes } from "./auth.routes";
import { SharedModule } from "@sharedModule";
import { RedirectComponent } from "@app/auth/components/redirect/redirect.component";
import { RegisterComponent } from "@app/auth/components/register/register.component";
import { VerifyComponent } from "@app/auth/components/verify/verify.component";
import { EmailVerifiedComponent } from "@app/auth/components/email_verified/email_verified.component";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { RegistrationParamsService } from "@app/brand_scraping/services/RegistrationParamsService";
import { PasswordResetComponent } from "@app/auth/components/password_reset/password_reset.component";
import { RECAPTCHA_V3_SITE_KEY, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings, RECAPTCHA_SETTINGS } from "ng-recaptcha";
import { environment } from "@environments/environment";
import { SpecialRegisterComponent } from "@app/auth/components/special_register/special_register.component";

@NgModule({
  declarations: [
    RedirectComponent,
    LoginComponent,
    PasswordResetComponent,
    RegisterComponent,
    VerifyComponent,
    EmailVerifiedComponent,
    SpecialRegisterComponent
  ],
  imports: [
    AuthRoutes,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    SharedModule,
    FontAwesomeModule,
    RecaptchaModule,
    RecaptchaFormsModule,
  ],
  providers: [
    RegistrationParamsService,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: environment.reCAPTCHASiteKey } as RecaptchaSettings,
    },
  ]
})
export class AuthModule {}
